import styled from 'styled-components';

const InfoTitle = styled.div`
  color: ${props => props.theme.infoTitle};
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
`;

export default InfoTitle;
